import { Button, Modal, Space, Input, Card, Form } from "antd";
import React, { useEffect, useRef, useState } from "react";
import styles from "./_styles.less";
import { formatCPF } from "@util/cpf";
import { signatarioService } from "../../services/signatarioService";

export default function ModalSignatario({ title = "Buscar signatário", isModalOpen, setIsModalOpen, empresaId = null, handleCardClick }) {
  const [searchResults, setSearchResults] = useState([]);
  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const handleSearch = (value) => {
    // if (!value) {
    //   setSearchResults([]);
    //   return;
    // }
    try {
      const service = empresaId ? signatarioService.searchCompanySigner : signatarioService.searchDefaultSigner;
      service(value, empresaId).then((res) => {
        if (!res || res.length === 0) setSearchResults(["Nenhum resultado"]);
        else setSearchResults(res);
      });
    } catch (erro) {
      setSearchResults(["Erro ao buscar: " + erro]);
    }
  };

  useEffect(() => {
    if (!isModalOpen) return;
    const timer = setTimeout(() => {
      const element = inputRef.current?.input ?? inputRef.current;
      element?.focus();
      element?.select();
    }, 100);

    return () => clearTimeout(timer);
  }, [isModalOpen]);

  return (
    <Modal title={title} open={isModalOpen} onOk={() => setIsModalOpen()} onCancel={() => setIsModalOpen()} footer={null} destroyOnClose>
      <Form form={form} className={styles["search-form"]}>
        <Form.Item name="search">
          <Input
            placeholder="Buscar por nome, email ou CPF"
            onBlur={(e) => handleSearch(e.target.value)}
            ref={inputRef}
            onPressEnter={(e) => {
              e.target.select();
              handleSearch(e.target.value);
            }}
            autoComplete="off"
          />
        </Form.Item>
        <Button
          onClick={() => {
            const value = form.getFieldValue("search");
            handleSearch(value);
          }}
        >
          Buscar
        </Button>
      </Form>

      <Space direction="vertical" style={{ marginTop: 10, width: "100%" }}>
        {searchResults?.map((item, key) => {
          const isEmpty = typeof item === "string"; // verifica se existe a string de aviso
          return (
            <Card
              key={key}
              hoverable
              style={{ display: "flex" }}
              onClick={() => {
                if (!isEmpty) {
                  handleCardClick && handleCardClick(item);
                  setIsModalOpen(false);
                }
              }}
            >
              {isEmpty ? (
                <span>{item}</span>
              ) : (
                <>
                  <span style={{ fontWeight: "bold", fontSize: 13, marginRight: 8 }}>{item.nome}</span>
                  <span style={{ color: "#777" }}>{item.email} - </span>
                  <span style={{ color: "#777" }}>{formatCPF(item.cpf) ?? "CPF não informado"}</span>
                </>
              )}
            </Card>
          );
        })}
      </Space>
    </Modal>
  );
}
